import Configs from '@/Configs';

/** Base path for the settings module (no trailing slash). */
export const SETTINGS_BASE_PATH = '/settings';

export const SETTINGS_ROUTES = {
  index: SETTINGS_BASE_PATH,
  personal: `${SETTINGS_BASE_PATH}/personal`,
  languageLegacy: `${SETTINGS_BASE_PATH}/language`,
  company: {
    index: `${SETTINGS_BASE_PATH}/company`,
    personalization: `${SETTINGS_BASE_PATH}/company/personalization`,
    integrations: `${SETTINGS_BASE_PATH}/company/integrations`,
    billing: `${SETTINGS_BASE_PATH}/company/billing`,
    kai: `${SETTINGS_BASE_PATH}/company/kai`,
    hrPocs: `${SETTINGS_BASE_PATH}/company/hr-pocs`,
    pulse: `${SETTINGS_BASE_PATH}/company/pulse`,
    calibration: `${SETTINGS_BASE_PATH}/company/calibration`,
    recognition: `${SETTINGS_BASE_PATH}/company/recognition`,
    goals: `${SETTINGS_BASE_PATH}/company/goals`,
    compliance: `${SETTINGS_BASE_PATH}/company/compliance`,
    punch: `${SETTINGS_BASE_PATH}/company/punch`,
    /** Generic read-only module settings (`SettingsCompanyModuleOverview`). */
    module: (moduleSlug: string) =>
      `${SETTINGS_BASE_PATH}/company/modules/${encodeURIComponent(moduleSlug)}`,
  },
  employeeSettings: {
    basePath: `${SETTINGS_BASE_PATH}/employee-settings`,
    tabs: {
      agreements: `${SETTINGS_BASE_PATH}/employee-settings/agreements`,
      contracts: `${SETTINGS_BASE_PATH}/employee-settings/contracts`,
      employeesWithoutContract: `${SETTINGS_BASE_PATH}/employee-settings/employees-without-contract`,
      projects: `${SETTINGS_BASE_PATH}/employee-settings/projects`,
      employeesWithoutProject: `${SETTINGS_BASE_PATH}/employee-settings/employees-without-project`,
      pending: `${SETTINGS_BASE_PATH}/employee-settings/pending`,
      pendingContract: `${SETTINGS_BASE_PATH}/employee-settings/pending?view=contract`,
      pendingProject: `${SETTINGS_BASE_PATH}/employee-settings/pending?view=project`,
      options: `${SETTINGS_BASE_PATH}/employee-settings/options`,
    },
  },
  timesheetLegacy: {
    base: `${SETTINGS_BASE_PATH}/timesheet`,
  },
} as const;

/** Prefixes that keep the Company tab active in the settings header. */
export const SETTINGS_COMPANY_TAB_PATH_PREFIXES = [SETTINGS_ROUTES.company.index] as const;

export const SETTINGS_PERSONAL_SECURITY_LEVELS = [
  Configs.securityLevelIC,
  Configs.securityLevelManager,
  Configs.securityLevelHR,
  Configs.securityLevelExec,
  Configs.securityLevelAdmin,
] as const;

export const SETTINGS_COMPANY_SECURITY_LEVELS = [
  Configs.securityLevelHR,
  Configs.securityLevelExec,
  Configs.securityLevelAdmin,
] as const;

/** Same roles as company settings: HR configures agreements/contracts/projects/punch options. */
export const SETTINGS_EMPLOYEE_SETTINGS_SECURITY_LEVELS = [
  Configs.securityLevelHR,
  Configs.securityLevelExec,
  Configs.securityLevelAdmin,
] as const;
